// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"8b78c257","241":"8c945188","389":"9666eeb5","503":"66656140","526":"c208c61c","846":"7b2ec178","854":"31893678","881":"33cdea40"}[chunkId] + ".chunk.js";
};